import axios from 'axios'
import { SLOW_REQUEST_CONFIG } from '../../util/loadingUtil'
import { URL } from '../../util/ambienteActions';

export default function replicarConfiguracaoSicoob(empresaId, configuracaoId, estadosDestino) {
  const url = `${URL}/empresas/${empresaId}/sicoob/chave-pix/${configuracaoId}/replicar`;
  return () => axios.post(url, estadosDestino, SLOW_REQUEST_CONFIG);
}
